import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '315维权，上游新闻百名律师为你免费支招！';

const route: RouteConfig = {
  path: '/20210311Xfz',
  name: 'Xfz',
  component: () => import('./Home.vue'),

  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
